import * as React from 'react';
import type { IPostsPageHeaderProps } from '@/@types/posts';

function PostsPageHeader({ title, count, subtitle }: IPostsPageHeaderProps) {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-3">
        <h1 className="text-[28px] font-bold text-foreground">{title}</h1>
        <span className="rounded-full bg-primary-foreground px-2.5 py-1 text-[13px] font-medium text-primary">
          {count} posts
        </span>
      </div>
      <p className="text-[14px] text-foreground-placeholder">{subtitle}</p>
    </div>
  );
}

const PostsPageHeaderMemo = React.memo(PostsPageHeader);

export { PostsPageHeaderMemo };
